// 引入公共函数
import * as publicMethods from './publicMethods';


export class UserDetailResp {

    /**
     * 用户的id
     */
    public user_ID: string;

    /**
     * 用户的账号
     */
    public account: string;

    /**
     * 工号或学号
     */
    public ghhxh: string;

    /**
     * 用户的角色
     */
    public role: Array<string>;

    /**
     * 手机号码
     */
    public phone: string;

    /**
     * 用户的名称
     */
    public name: string;

    /**
     * 邮箱
     */
    public email: string;

    /**
     * 性别
     */
    public sex: string;

    /**
     * 用户的权限集合
     */
    public permissions: Array<string> = [];

    constructor(data: any) {
        this.user_ID = publicMethods.setNullStr(data.user_ID);
        this.account = publicMethods.setNullStr(data.account);
        this.ghhxh = publicMethods.setNullStr(data.ghhxh);
        this.role = publicMethods.setNullStr(data.role);
        this.phone = publicMethods.setNullStr(data.phone);
        this.name = publicMethods.setNullStr(data.name);
        this.email = publicMethods.setNullStr(data.email);
        this.sex = publicMethods.setNullStr(data.sex);
        if (data.permissions && data.permissions.length > 0) {
            this.permissions = data.permissions;
        }
    }
}